import { useEffect,useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Autocomplete, Card, CardContent, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import axios from 'axios'
import Button from '../../../components/Button'
import { post } from '../../../utils/axios'
import { toast } from 'react-toastify'

const Create = () => {

    const navigate = useNavigate()

    const [isLoading,setIsLoading] = useState(false)
    const [type,setType] = useState('support')
    const [topics,setTopics] = useState([])
    const [businesses,setBusinesses] = useState([])
    const [businessId,setBusinessId] = useState('')
    const [topicId,setTopicId] = useState('')
    const [message,setMessage] = useState('')

    useEffect(() => {
        const postedData = {
            guildId: 64
        }
        post('Business/GetAllBusinessByGuild',postedData).then(({ data }) => {
            if(data.isSuccess){
                const items = []
                data.data.map(item => items.push({
                    label: item.title,
                    id: item.id
                }))
                setBusinesses(items)
            }
        })
        axios.post('https://petromah.sabinarya.com/service/api/Support/getTopics').then(({ data }) => {
            if(data.status)
                setTopics(data.result)
        })
    },[])

    const addRequest = () => {
        setIsLoading(true)
        const postedData = {
            categoryType: type == 'support' ? 2 : 1,
            topicId,
            ticketMessage: message,
        }
        if(type != 'support' && businessId)
            postedData.businessId = businessId
        post('Support/AddRequest',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('درخواست شما با موفقیت ثبت شد')
                navigate('/app/tickets')
            }else
                toast.error(data.message)
        })
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">ایجاد درخواست جدید</h3>
            <div className="safe-area">
                <Card sx={{mb: 5}}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl>
                                    <FormLabel id="ticket-type">نوع درخواست</FormLabel>
                                    <RadioGroup row aria-labelledby="ticket-type" name="row-radio-buttons-group" value={type} onChange={e => setType(e.target.value)} >
                                        <FormControlLabel value="support" control={<Radio />} label="پشتیبانی" />
                                        <FormControlLabel value="complaint" control={<Radio />} label="شکایت" />
                                    </RadioGroup>
                                </FormControl>
                                <FormControl fullWidth sx={{my: 2.5}}>
                                    <InputLabel id="app-theme-label">موضوع درخواست</InputLabel>
                                    <Select labelId="app-theme-label" id="app-theme" value={topicId} label="موضوع درخواست" onChange={e => setTopicId(e.target.value)}>
                                        <MenuItem disabled>انتخاب کنید</MenuItem>
                                        {topics.filter(t => (t.criticism && type == 'complaint') || (!t.criticism && type == 'support')).map(topic => <MenuItem value={topic.id}>{topic.title}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                {type != 'support' ? <FormControl fullWidth sx={{mb: 3}}>
                                    <Autocomplete
                                        options={businesses}
                                        autoHighlight
                                        value={businesses.find(business => business.id == businessId)}
                                        onChange={(e,value) => setBusinessId(value?.id || 0)}
                                        getOptionLabel={(option) => option.label}
                                        noOptionsText="یافت نشد"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="کسب و کار"
                                                inputProps={{
                                                    ...params.inputProps
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl> : ''}
                                <TextField label="متن درخواست (حداقل 15 کاراکتر)" variant="standard" multiline rows={5} fullWidth sx={{mb: 2.5}} onChange={e => setMessage(e.target.value)} value={message} />
                                <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 2,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!topicId || !message || message.length < 15} onClick={addRequest}>ایجاد درخواست</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default Create